import { render } from "./ReportsTable.vue?vue&type=template&id=632324ca"
import script from "./ReportsTable.vue?vue&type=script&lang=ts"
export * from "./ReportsTable.vue?vue&type=script&lang=ts"

import "./ReportsTable.vue?vue&type=style&index=0&id=632324ca&lang=scss"
script.render = render

export default script